import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { box } from '../../../../../../style/mixins';

export const Box = styled.div`
  ${box}
  margin-bottom: 20px;
  padding: 20px;
  width: ${mixins.getColSize(8)};
`;

export const OrderDetailsBox = styled(Box)`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  padding: 20px;
`;

export const OrderDetailsItem = styled.div``;

export const OrderId = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_3,
    styles.fontWeights.BOLD
  )}
  line-height: 34px;
`;

export const OrderDate = styled.div`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_6, styles.fontWeights.NORMAL)}
  line-height: 19px;
  margin-left: 10px;
`;

export const OrderTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OrderScheduled = styled.div`
  display: flex;
  font-size: 14px;
  margin: 0 10px;

  > span {
    color: #a0a0a0;
  }

  > p {
    color: #333333;
    margin-left: 5px;
  }
`;

export const OrderTypeItem = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  margin: 0 10px;
  max-width: 200px;
`;

export const OrderTypeDescription = styled.div`
  ${({ color }) =>
    mixins.fontStyle(
      color || styles.colors.MAIN_COLOR,
      styles.fontSizes.SIZE_7,
      styles.fontWeights.BOLD
    )}
  margin-left: 12px;
`;

export const OrderStatus = styled.span`
  display: block;
  line-height: 17px;
  margin-top: 1px;
`;

export const OrderMethod = styled.span`
  display: block;
  line-height: 17px;
`;

export const OrderDisplay = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_6, styles.fontWeights.NORMAL)}
`;

export const OrderDisplayFirst = styled.div`
  margin-right: 6px;
`;

export const OrderDisplayLast = styled.div`
  margin-left: 6px;
`;

export const OrderMethodText = styled.div``;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/Header/style.js